import "./OlelTermsOfSale.css";
import React from "react";

function OlelTermsOfSale() {
  return (
    <div className="OlelTermsOfSale">
      <h1 id="特定商取引法に基づく表示">特定商取引法に基づく表示</h1>
      <h2 id="名称">名称</h2>
      <p>浅野 大輝（Hiroki Asano）</p>
      <h2 id="メールアドレス">メールアドレス</h2>
      <p>asano.hiroki@gmail.com</p>
      <h2 id="サービスの提供期間">サービスの提供期間</h2>
      <ul>
        <li>月額プラン：利用期間開始日から1か月間</li>
        <li>年額プラン：利用期間開始日から1年間</li>
      </ul>
      <p>
        なお、いずれのプランも、当方の定める方法によりご解約いただかない限り、自動更新となります。
      </p>
      <h2 id="利用料金">利用料金</h2>
      <p>各プランの申込みページにて記載されている料金（税込み）となります。</p>
      <h2 id="対価以外に必要となる費用">対価以外に必要となる費用</h2>
      <p>
        インターネット接続料金その他の電気通信回線の通信に関する費用はユーザーにて別途ご用意いただく必要があります（金額は、ユーザーが契約した各事業者が定める通り）。
      </p>
      <h2 id="支払方法">支払方法</h2>
      <p>App Storeにてお支払いいただきます。</p>
      <h2 id="支払時期">支払時期</h2>
      <p>
        サービスのご利用開始時に、ユーザーが選択された期間分の利用料金を先払いにてお支払いいただきます。
        当該お支払いにかかるご利用期間終了の24時間前までに当方所定の方法によりご解約いただかない限り、サービスは自動更新となり、更新期間満了時までに同一期間分の利用料金（更新日時点で料金が改定される場合は、改定後の利用料金）をお支払いいただくものとし、以後も同様となります。
        無料体験期間が設定されているプランの場合、無料体験期間の終了の24時間前までに当方所定の方法によりご解約いただかない限り、無料体験期間の終了と同時に自動的に利用料金の支払いが発生いたします。
        なお、実際のユーザーの銀行口座からの引き落とし日は、ご利用のクレジットカード（App
        Storeのアカウントに登録されたクレジットカード）の締め日や契約内容により異なります。ご利用されるカード会社までお問い合わせください。
      </p>
      <h2 id="サービス提供の時期">サービス提供の時期</h2>
      <p>当方所定の手続き終了後、直ちにご利用いただけます。</p>
      <h2 id="サービスの申込みの撤回解除に関する事項">
        サービスの申込みの撤回・解除に関する事項
      </h2>
      <p>
        購入手続完了後のお申し込みの撤回や返金については、App
        Storeの返金ポリシーに従います。
        利用期間開始後の期間中の解約のお申し出はいつでも可能ですが、その解約の効力は利用期間満了時において発生するものとします。
      </p>
      <h2 id="推奨動作環境">推奨動作環境</h2>
      <ul>
        <li>
          iOS
          <ul>
            <li>OS：iOS 17.5以降</li>
            <li>アプリバージョン：App Storeで提供している最新バージョン</li>
          </ul>
        </li>
      </ul>
      <h2 id="特別条件">特別条件</h2>
      <p>
        本サービスは、特定商取引法に規定されるクーリングオフが適用されるサービスではありません。
      </p>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
    </div>
  );
}

export default OlelTermsOfSale;
